module.exports = __webpack_public_path__ + "img/logo-ledger.7ae27abf.png";